/**
 * Countdown Timer
 * Odlicza czas do daty docelowej ustawionej w data-countdown-target.
 * Aktualizuje kafelki co 1 sekundę.
 */

(function () {
  'use strict';

  var container = document.querySelector('[data-countdown-target]');

  if (!container) return;

  var targetDate = new Date(container.getAttribute('data-countdown-target')).getTime();
  var daysEl = container.querySelector('[data-countdown-days]');
  var hoursEl = container.querySelector('[data-countdown-hours]');
  var minutesEl = container.querySelector('[data-countdown-minutes]');
  var secondsEl = container.querySelector('[data-countdown-seconds]');

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

  function pad(num) {
    return num < 10 ? '0' + num : String(num);
  }

  function update() {
    var now = new Date().getTime();
    var diff = targetDate - now;

    if (diff <= 0) {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      clearInterval(timer);
      return;
    }

    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);

    daysEl.textContent = pad(days);
    hoursEl.textContent = pad(hours);
    minutesEl.textContent = pad(minutes);
    secondsEl.textContent = pad(seconds);
  }

  update();
  var timer = setInterval(update, 1000);
})();
